(ns manage.campaign-tags-page.db
  (:require [clojure.string :as str]
            [common.url-template :as url-tpl]
            [manage.campaign-tags-page.effect :as effect]
            [mate.core :as mc]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(rf/reg-event-fx :campaign-tags.page/get-page
  [(rf/inject-cofx :sub :url-context)
   (rf/inject-cofx :sub :resource.user/token)]
  (fn [{:keys [db url-context resource.user/token]} [_ campaign-tags-id]]
    (when (nil? (-> db :resource.campaign-tags/page :state))
      (let [url-context (assoc url-context
                               :campaign-tags-id campaign-tags-id)]
        (-> {:db db}
            (effect/set-campaign-tags-resource {:state :pending
                                                :value nil})
            (effect/get-campaign-tags-page url-context token
                                           [:campaign-tags.page/get-page-on-success]
                                           [:campaign-tags.page/get-page-on-failure]))))))

(defn- derive-vast-ad-types [vast-ad-types]
  (or vast-ad-types []))

(rf/reg-event-fx :campaign-tags.page/get-page-on-success
  [(rf/inject-cofx :sub :url-context)
   (rf/inject-cofx :sub :resource.user/token)]
  (fn [{:keys [db url-context resource.user/token]} [_ campaign-tags]]
    (let [video-ctv-adsets (->> (:tags campaign-tags)
                                (filter (comp #{"video" "ctv"} :adset-channel)))]
      (reduce (fn [effects {:keys [adset-id]}]
                (mr/conj-fx effects
                            [:http {:method :get
                                    :uri (url-tpl/render :api/adset-vast-ad-types
                                                         (assoc url-context
                                                                :advertiser-id (:advertiser-id campaign-tags)
                                                                :adset-id adset-id))
                                    :headers {"Authorization" token}
                                    :on-success [:campaign-tags.page/fetch-adset-vast-ad-types-success adset-id]
                                    :on-failure [:campaign-tags.page/fetch-adset-vast-ad-types-failure adset-id]}]))
              (-> {:db db}
                  (effect/set-campaign-tags-resource {:state :success
                                                      :value campaign-tags})
                  (effect/set-campaign-tags-settings campaign-tags))
              video-ctv-adsets))))

(rf/reg-event-db :campaign-tags.page/fetch-adset-vast-ad-types-success
  (fn [db [_ adset-id vast-ad-types]]
    (assoc-in db [:campaign-tags.page/vast-ad-types-by-adset-id adset-id] vast-ad-types)))

(rf/reg-event-db :campaign-tags.page/fetch-adset-vast-ad-types-failure
  (fn [db _] db))

(rf/reg-event-fx :campaign-tags.page/get-page-on-failure
  (fn [{:keys [db]} _]
    (-> {:db db}
        (effect/set-campaign-tags-resource {:state :failure}))))

(rf/reg-event-fx :campaign-tags.page/cleanup
  (fn [{:keys [db]} _]
    (-> {:db db}
        (effect/remove-campaign-tags-resource)
        (mr/update-db dissoc :campaign-tags.page/settings :campaign-tags.page/selection :campaign-tags.page/export-status :campaign-tags.page/vast-ad-types-by-adset-id))))

(rf/reg-event-fx :campaign-tags.page/export-excel-file
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)
   (rf/inject-cofx :sub :resource.campaign-tags/page-value)]
  (fn [{:keys [db
               resource.user/token
               url-context
               resource.campaign-tags/page-value]} _]
    (-> {:db db}
        (effect/export-excel-tags {:token token
                                   :url-context url-context
                                   :dsps (:dsps page-value)
                                   :additional-settings (select-keys page-value [:gdpr :click-tag])
                                   :advertiser-id (:advertiser-id page-value)
                                   :adset-ids (:adset-ids page-value)
                                   :on-success [:campaign-tags.page/on-export-excel-file-success]
                                   :on-failure [:campaign-tags.page/on-export-excel-file-failure]}))))

(rf/reg-event-fx :campaign-tags.page/on-export-excel-file-success
  (fn [{:keys [db]} [_ response]]
    (-> {:db db}
        (effect/on-export-excel-tags-success response))))

(rf/reg-event-fx :campaign-tags.page/on-export-excel-file-failure
  (fn [{:keys [db]} [_ error]]
    (-> {:db db}
        (effect/on-export-excel-tags-failure error))))

(rf/reg-event-fx :campaign-tags.page/save
  [(rf/inject-cofx :sub :campaign-tags.page/url-context)
   (rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :campaign-tags.page/settings)]
  (fn [{:keys [db
               campaign-tags.page/url-context
               resource.user/token
               campaign-tags.page/settings]} _]
    (-> {:db db}
        (effect/patch-campaign-tags-page url-context token settings
                                         [:toaster-bus/add {:id ::copied->clipboard
                                                            :type :success
                                                            :message "The current settings are saved as default."}]
                                         [:toaster-bus/add {:id ::copied->clipboard
                                                            :type :error
                                                            :message "Could not save the current settings."}]))))

(rf/reg-event-fx :campaign-tags.page/copy-to-clipboard
  (fn [_ [_ tag-text]]
    {:fx [[:content->clipboard {:content tag-text
                                :success #(rf/dispatch [:toaster-bus/add {:id ::copied->clipboard
                                                                          :type :success
                                                                          :message "Copied to clipboard"}])
                                :error #(rf/dispatch [:toaster-bus/add {:id ::copied->clipboard
                                                                        :type :error
                                                                        :message "Could not copy to clipboard"}])}]]}))

(rf/reg-sub :resource.campaign-tags/page-value
  (fn [db _]
    (-> db :resource.campaign-tags/page :value)))

(rf/reg-sub :resource.campaign-tags/page-state
  (fn [db _]
    (-> db :resource.campaign-tags/page :state)))

(rf/reg-sub :campaign-tags.page/url-context
  :<- [:url-context]
  :<- [:resource.campaign-tags/page-value]
  (fn [[url-context campaign-tags-page] _]
    (let [campaign-tags-id                    (-> campaign-tags-page :id)
          agency-id                           (-> campaign-tags-page :agency-id)
          {:keys [advertiser-id campaign-id]} (-> campaign-tags-page :tags first)]
      (assoc url-context
             :agency-id agency-id
             :advertiser-id advertiser-id
             :campaign-id campaign-id
             :campaign-tags-id campaign-tags-id))))

(rf/reg-sub :campaign-tags.page/adset-tags
  :<- [:resource.campaign-tags/page-value]
  (fn [campaign-tags-page _]
    (-> campaign-tags-page :tags)))

(rf/reg-sub :campaign-tags.page/vast-ad-types-by-adset-id
  (fn [db _]
    (:campaign-tags.page/vast-ad-types-by-adset-id db {})))

(rf/reg-sub :campaign-tags.page/filtered-row-ids
  :<- [:campaign-tags.page/adset-tags]
  :<- [:campaign-tags.page.settings/value :video]
  :<- [:campaign-tags.page.settings/value :display]
  :<- [:campaign-tags.page.settings/value :dsp]
  :<- [:campaign-tags.page.settings/value :dimension]
  :<- [:campaign-tags.page/vast-ad-types-by-adset-id]
  (fn [[adset-tags include-video include-display dsp dimension vast-ad-types-by-adset-id] _]
    (let [channels-to-include (cond-> #{}
                                include-video (conj "video" "ctv")
                                include-display (conj "display"))]
      (for [[adset-index adset] (mc/seq-indexed adset-tags)
            :when (contains? channels-to-include (:adset-channel adset))
            [tag-index tag] (mc/seq-indexed (:tags adset))
            :when (or (= dsp "all")
                      (= dsp (:dsp tag)))
            :when (or (= dimension "all")
                      (= dimension (:size tag)))
            :let [vast-ad-types (derive-vast-ad-types (get vast-ad-types-by-adset-id (:adset-id adset)))
                  ad-types (if (< 1 (count vast-ad-types)) vast-ad-types [nil])]
            vast-ad-type ad-types]
        [adset-index tag-index vast-ad-type]))))

(rf/reg-sub :campaign-tags.page/all-tag-dsps
  :<- [:campaign-tags.page/adset-tags]
  (fn [adset-tags _]
    (->> adset-tags
         (mapcat :tags)
         (keep :dsp)
         (remove nil?)
         set ; de-duplicates the sizes
         sort)))

(rf/reg-sub :campaign-tags.page/all-tag-sizes
  :<- [:campaign-tags.page/adset-tags]
  (fn [adset-tags _]
    (->> adset-tags
         (filter (comp #{"display"} :adset-channel)) ; Gathers the sizes only from the display adsets.
         (mapcat :tags)
         (keep :size)
         set ; de-duplicates the sizes
         sort)))

;;
;; Settings state
;;

(rf/reg-sub :campaign-tags.page/settings
  (fn [db _]
    (:campaign-tags.page/settings db)))

(rf/reg-event-db :campaign-tags.page.settings/set-value
  (fn [db [_ attribute-id value]]
    (-> db
        (assoc-in [:campaign-tags.page/settings attribute-id] value)
        (cond-> (= attribute-id :display-tag-type)
          (update :campaign-tags.page/settings dissoc :grid-row-display-tag-type)))))

(rf/reg-sub :campaign-tags.page.settings/value
  :<- [:campaign-tags.page/settings]
  (fn [settings [_ attribute-id]]
    (-> settings
        (get attribute-id))))

(rf/reg-sub :campaign-tags.page.settings/grid-row-display-tag-type
  :<- [:campaign-tags.page/settings]
  :<- [:campaign-tags.page.settings/value :display-tag-type]
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [[settings dropdown-display-tag-type data-by-row-id] [_ row-id]]
    (let [{:keys [adset]} (-> row-id data-by-row-id)]
      (-> settings
          (get-in [:grid-row-display-tag-type row-id]
                  (case (:adset-channel adset)
                    ("video" "ctv") "secure"
                    "display" dropdown-display-tag-type))))))

(rf/reg-sub :campaign-tags.page.settings/grid-row-display-tag-version
  :<- [:campaign-tags.page/settings]
  (fn [settings [_ row-id]]
    (get-in settings [:grid-row-display-tag-version row-id])))

(rf/reg-event-db :campaign-tags.page.settings/set-grid-row-display-tag-type
  (fn [db [_ row-id value]]
    (-> db
        (assoc-in [:campaign-tags.page/settings :grid-row-display-tag-type row-id] value))))

(rf/reg-event-db :campaign-tags.page.settings/set-vast-version
  (fn [db [_ row-id value]]
    (-> db
        (assoc-in [:campaign-tags.page/settings :grid-row-display-tag-version row-id] value))))

;; This subscription is a lookup table used by each grid-row.
(rf/reg-sub :campaign-tags.page/data-by-row-id
  :<- [:resource.campaign-tags/page-value]
  :<- [:campaign-tags.page/vast-ad-types-by-adset-id]
  (fn [[campaign-tags-page vast-ad-types-by-adset-id] _]
    (->> (for [[adset-index adset] (mc/seq-indexed (:tags campaign-tags-page))
               [tag-index tag] (mc/seq-indexed (:tags adset))
               :let [vast-ad-types (derive-vast-ad-types (get vast-ad-types-by-adset-id (:adset-id adset)))
                     ad-types (if (< 1 (count vast-ad-types)) vast-ad-types [nil])]
               vast-ad-type ad-types
               :let [row-id [adset-index tag-index vast-ad-type]]]
           [row-id {:adset adset, :tag tag, :vast-ad-type vast-ad-type}])
         (into {}))))

(rf/reg-sub :campaign-tags.page/grid-row-tag-info
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [data-by-row-id [_ row-id]]
    (-> row-id data-by-row-id :tag :info)))

(defn- vast-url-with-type [url vast-ad-type]
  (when url
    (if-let [q-pos (str/index-of url "?")]
      (str (subs url 0 q-pos) "/type/" vast-ad-type "?" (subs url (inc q-pos)))
      (str url "/type/" vast-ad-type))))

(rf/reg-sub :campaign-tags.page/grid-row-tag-text
  (fn [[_ row-id]]
    [(rf/subscribe [:campaign-tags.page/data-by-row-id])
     (rf/subscribe [:campaign-tags.page.settings/grid-row-display-tag-type row-id])
     (rf/subscribe [:campaign-tags.page.settings/grid-row-display-tag-version row-id])])
  (fn [[data-by-row-id display-tag-type tag-version] [_ row-id]]
    (let [{:keys [adset tag vast-ad-type]} (-> row-id data-by-row-id)]
      (-> (case (:adset-channel adset)
            ("video" "ctv") (case display-tag-type
                              "secure"
                              (if (and tag-version (= tag-version :4.0))
                                (-> tag :vast-versions tag-version :url)
                                (cond-> (:vast tag)
                                  vast-ad-type (vast-url-with-type vast-ad-type)))
                              "insecure"
                              (if (and tag-version (= tag-version :4.0))
                                (-> tag :vast-versions tag-version :insecure-url)
                                (cond-> (:insecure-vast tag)
                                  vast-ad-type (vast-url-with-type vast-ad-type))))
            "display" (case display-tag-type
                        "ins" (:iframe tag)
                        "js" (:script tag)
                        "cm360" (:cm360 tag)))
          str))))

(rf/reg-sub :campaign-tags.page/grid-row-adset-channel
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [data-by-row-id [_ row-id]]
    (-> row-id data-by-row-id :adset :adset-channel)))

(rf/reg-sub :campaign-tags.page/grid-row-adset-name
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [data-by-row-id [_ row-id]]
    (-> row-id data-by-row-id :adset :adset-name)))

(rf/reg-sub :campaign-tags.page/grid-row-vast-ad-type
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [data-by-row-id [_ row-id]]
    (-> row-id data-by-row-id :vast-ad-type)))

(rf/reg-sub :campaign-tags.page/grid-row-dsp
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [data-by-row-id [_ row-id]]
    (-> row-id data-by-row-id :tag :dsp)))

(rf/reg-sub :campaign-tags.page/grid-row-dimensions
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [data-by-row-id [_ row-id]]
    (-> row-id data-by-row-id :tag (select-keys [:width :height :size]))))

(rf/reg-sub :campaign-tags.page/first-display-adset
  :<- [:campaign-tags.page/adset-tags]
  (fn [adset-tags _]
    (->> adset-tags
         (filter #(= "display" (:adset-channel %)))
         first)))

;;
;; Selection state management
;;

(rf/reg-event-db :campaign-tags.page.selection/toggle-row
  (fn [db [_ row-id]]
    (let [selected-rows (get-in db [:campaign-tags.page/selection :selected-row-ids] #{})]
      (assoc-in db [:campaign-tags.page/selection :selected-row-ids]
                (if (contains? selected-rows row-id)
                  (disj selected-rows row-id)
                  (conj selected-rows row-id))))))

(rf/reg-event-fx :campaign-tags.page.selection/toggle-all-cm360
  [(rf/inject-cofx :sub :campaign-tags.page.selection/cm360-row-ids)
   (rf/inject-cofx :sub :campaign-tags.page.selection/selected-row-ids)]
  (fn [{:keys [db :campaign-tags.page.selection/cm360-row-ids :campaign-tags.page.selection/selected-row-ids]} _]
    (let [cm360-rows (set cm360-row-ids)
          all-cm360-selected? (and (seq cm360-rows) (every? selected-row-ids cm360-rows))]
      {:db (assoc-in db [:campaign-tags.page/selection :selected-row-ids]
                     (if all-cm360-selected?
                       (apply disj selected-row-ids cm360-rows)
                       (into selected-row-ids cm360-rows)))})))

(rf/reg-sub :campaign-tags.page.selection/selected-row-ids
  (fn [db _]
    (get-in db [:campaign-tags.page/selection :selected-row-ids] #{})))

(rf/reg-sub :campaign-tags.page.selection/cm360-row-ids
  :<- [:campaign-tags.page/filtered-row-ids]
  :<- [:campaign-tags.page/data-by-row-id]
  (fn [[filtered-row-ids data-by-row-id] _]
    (filter (fn [row-id]
              (let [tag (-> row-id data-by-row-id :tag)]
                (some? (:cm360 tag))))
            filtered-row-ids)))

(rf/reg-sub :campaign-tags.page.selection/is-row-selected
  :<- [:campaign-tags.page.selection/selected-row-ids]
  (fn [selected-row-ids [_ row-id]]
    (contains? selected-row-ids row-id)))

(rf/reg-sub :campaign-tags.page.selection/selected-cm360-count
  :<- [:campaign-tags.page.selection/selected-row-ids]
  :<- [:campaign-tags.page.selection/cm360-row-ids]
  (fn [[selected-row-ids cm360-row-ids] _]
    (count (filter (set selected-row-ids) cm360-row-ids))))

(defn- has-multiple-adsets? [campaign-tags-page]
  (> (count (:tags campaign-tags-page)) 1))

(rf/reg-sub :campaign-tags.page/has-multiple-adsets?
  :<- [:resource.campaign-tags/page-value]
  (fn [campaign-tags-page _]
    (has-multiple-adsets? campaign-tags-page)))

;;
;; Export status state management
;;

(rf/reg-event-db :campaign-tags.page.export-status/set-row-status
  (fn [db [_ row-id status]]
    (assoc-in db [:campaign-tags.page/export-status :row-statuses row-id] status)))

(rf/reg-sub :campaign-tags.page.export-status/row-status
  (fn [db [_ row-id]]
    (get-in db [:campaign-tags.page/export-status :row-statuses row-id])))

(def ^:private export-delay-ms 150)

(defn- build-export-payload [tag form-value campaign-tags-page adset multiple-adsets?]
  (let [{:keys [exportName adserveraccountconfigurationId]} form-value
        {:keys [template-revision-id width height]} tag
        dsp-name (:dsp tag)
        effective-export-name (if multiple-adsets?
                                (:adset-name adset)
                                exportName)]
    {:exportType "direct"
     :exportSubtype "custom"
     :adserveraccountconfigurationId adserveraccountconfigurationId
     :exportName effective-export-name
     :templateRevisionId template-revision-id
     ;; Tags of adsets without template revisions all have a nil
     ;; template-revision-id, so the size is what identifies them.
     :width width
     :height height
     :dsp dsp-name
     :campaignTagId (:id campaign-tags-page)}))

(rf/reg-event-fx :form.export-display-tag/bulk-export
  [(rf/inject-cofx :sub :campaign-tags.page.selection/selected-row-ids)
   (rf/inject-cofx :sub :campaign-tags.page.selection/cm360-row-ids)
   (rf/inject-cofx :sub :campaign-tags.page/url-context)
   (rf/inject-cofx :sub :resource.user/token)]
  (fn [{:keys [db
               :campaign-tags.page.selection/selected-row-ids
               :campaign-tags.page.selection/cm360-row-ids
               :campaign-tags.page/url-context
               :resource.user/token]} _]
    (let [form-value (get-in db [:form.export-display-tag :value])
          selected-cm360-rows (filter (set selected-row-ids) cm360-row-ids)]
      {:dispatch-n [[:ocp/close]
                    [:loader/open]
                    [:campaign-tags.page/process-next-export]]
       :db (-> db
               (assoc :campaign-tags.page/last-export-form-value form-value)
               (assoc-in [:campaign-tags.page/bulk-export]
                         {:selected-rows selected-cm360-rows
                          :url-context url-context
                          :user-token token
                          :current-index 0}))})))

(rf/reg-event-fx :campaign-tags.page/process-next-export
  [(rf/inject-cofx :sub :campaign-tags.page/data-by-row-id)]
  (fn [{:keys [db :campaign-tags.page/data-by-row-id]} _]
    (let [{:keys [selected-rows current-index url-context user-token]} (get-in db [:campaign-tags.page/bulk-export])
          form-value (get db :campaign-tags.page/last-export-form-value)
          row-id (nth selected-rows current-index nil)]
      (if row-id
        (let [campaign-tags-page (get-in db [:resource.campaign-tags/page :value])
              tag-data (get data-by-row-id row-id)
              {:keys [adset tag]} tag-data
              multiple-adsets? (has-multiple-adsets? campaign-tags-page)]

          {:db (update-in db [:campaign-tags.page/bulk-export :current-index] inc)
           :fx [[:dispatch [:campaign-tags.page.export-status/set-row-status row-id :in-progress]]]
           :http {:method :post
                  :uri (url-tpl/render :api/adset-exports (assoc url-context :adset-id (:adset-id adset)))
                  :headers {"Authorization" user-token}
                  :params (build-export-payload tag form-value campaign-tags-page adset multiple-adsets?)
                  :on-success [:campaign-tags.page/bulk-export-http-success row-id]
                  :on-failure [:campaign-tags.page/bulk-export-http-failure row-id]}})

        {:dispatch [:loader/close]
         :db (dissoc db :campaign-tags.page/bulk-export)}))))

(rf/reg-event-fx :campaign-tags.page/bulk-export-http-success
  (fn [_ [_ row-id response]]
    (let [template-exports (get response :templateExports)
          has-error? (some #(= "error" (get % :status)) template-exports)
          error-message (map (fn [{:keys [type message]}]
                               (str type ": " message)) template-exports)]
      {:fx (cond-> [[:dispatch [:campaign-tags.page.export-status/set-row-status row-id (if has-error? :failed :success)]]
                    [:dispatch-later {:ms export-delay-ms :dispatch [:campaign-tags.page/process-next-export]}]]
             has-error?
             (conj [:dispatch [:toaster-bus/add {:id ::export-error
                                                 :type :error
                                                 :message "There was an error during tag export."
                                                 :full-message error-message}]]))})))

(rf/reg-event-fx :campaign-tags.page/bulk-export-http-failure
  (fn [_ [_ row-id error]]
    {:fx [[:dispatch [:campaign-tags.page.export-status/set-row-status row-id :failed]]
          [:dispatch [:toaster-bus/add {:id ::export-failure
                                        :type :error
                                        :message "Failed to export tag. Please try again."
                                        :full-message error}]]
          [:dispatch-later {:ms export-delay-ms :dispatch [:campaign-tags.page/process-next-export]}]]}))

(rf/reg-event-fx :campaign-tags.page/retry-single-export
  [(rf/inject-cofx :sub :campaign-tags.page/data-by-row-id)
   (rf/inject-cofx :sub :campaign-tags.page/url-context)
   (rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :resource.campaign-tags/page-value)]
  (fn [{:keys [db] :as cofx} [_ row-id]]
    (let [data-by-row-id (get cofx :campaign-tags.page/data-by-row-id)
          form-value (get db :campaign-tags.page/last-export-form-value)
          url-context (get cofx :campaign-tags.page/url-context)
          user-token (get cofx :resource.user/token)
          campaign-tags-page (get cofx :resource.campaign-tags/page-value)
          tag-data (get data-by-row-id row-id)]

      (if-not (some? (:adserveraccountconfigurationId form-value))
        {:dispatch [:toaster-bus/add {:id ::retry-export-error
                                      :type :error
                                      :message "Cannot retry export: export configuration is missing. Please re-run a bulk export first."}]}

        (let [{:keys [adset tag]} tag-data
              multiple-adsets? (has-multiple-adsets? campaign-tags-page)]
          {:fx [[:dispatch [:campaign-tags.page.export-status/set-row-status row-id :in-progress]]]
           :http {:method :post
                  :uri (url-tpl/render :api/adset-exports (assoc url-context :adset-id (:adset-id adset)))
                  :headers {"Authorization" user-token}
                  :params (build-export-payload tag form-value campaign-tags-page adset multiple-adsets?)
                  :on-success [:campaign-tags.page/retry-export-http-success row-id]
                  :on-failure [:campaign-tags.page/retry-export-http-failure row-id]}})))))

(rf/reg-event-fx :campaign-tags.page/retry-export-http-success
  (fn [_ [_ row-id response]]
    (let [template-exports (get response :templateExports)
          has-error? (some #(= "error" (get % :status)) template-exports)
          error-message (map (fn [{:keys [type message]}]
                               (str type ": " message)) template-exports)]
      {:fx (cond-> [[:dispatch [:campaign-tags.page.export-status/set-row-status row-id (if has-error? :failed :success)]]]
             has-error?
             (conj [:dispatch [:toaster-bus/add {:id ::export-error
                                                 :type :error
                                                 :message "There was an error during tag export."
                                                 :full-message error-message}]]))})))

(rf/reg-event-fx :campaign-tags.page/retry-export-http-failure
  (fn [_ [_ row-id error]]
    {:fx [[:dispatch [:campaign-tags.page.export-status/set-row-status row-id :failed]]
          [:dispatch [:toaster-bus/add {:id ::export-failure
                                        :type :error
                                        :message "Failed to retry export. Please try again."
                                        :full-message error}]]]}))
